export function parsePaginatedResponse(result) {
    if (result?.status !== 200) {
        return {
            items: [],
            pagination: { total: 0, last_page: 1, current_page: 1, per_page: 10 },
        };
    }

    const payload = result.data?.data;
    const items = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
            ? payload.data
            : [];
    const pagination = result.data?.pagination || {};

    return {
        items,
        pagination: {
            total: pagination.total ?? items.length,
            last_page: pagination.last_page ?? 1,
            current_page: pagination.current_page ?? 1,
            per_page: pagination.per_page ?? 10,
        },
    };
}
